module.exports = __webpack_public_path__ + "img/sylvain-grosdemouge.7959e15f.jpg";